import { PredictTagStrings } from "constants/constantStrings";

const WATER_PREDICTION_TAGS = ["TAG021", "TAG023", "TAG025"];
const CHEMICAL_PREDICTION_TAGS = ["TAG062"];

const PREDICTION_DURATION = {
  ONE_DAY: "1 day",
  ONE_WEEK: "1 week",
  ONE_MONTH: "1 month"
};

export const PREDICTION_TIMES = {
  [PREDICTION_DURATION.ONE_DAY]: PredictTagStrings.nextDay,
  [PREDICTION_DURATION.ONE_WEEK]: PredictTagStrings.nextWeek,
  [PREDICTION_DURATION.ONE_MONTH]: PredictTagStrings.nextMonth
};

const PREDICTION_MODELS = [
  { id: "water", name: PredictTagStrings.waterPrediction },
  { id: "chemical", name: PredictTagStrings.chemicalPrediction }
];

const PREDICTION_FORM_CONST = {
  WATER_PREDICTION_TAGS,
  CHEMICAL_PREDICTION_TAGS,
  PREDICTION_DURATION,
  PREDICTION_TIMES,
  PREDICTION_MODELS
};

export default PREDICTION_FORM_CONST;
